module.exports = __webpack_public_path__ + "static/media/ban_main.fb4b2a72.jpg";